import { CompanyClientResponseDataSchema } from "schema"
import { z } from "zod"

type CompanyClient = z.infer<typeof CompanyClientResponseDataSchema>

export function formatCompanyClient(client: CompanyClient): string
export function formatCompanyClient(client: CompanyClient | null | undefined): string | null
export function formatCompanyClient(client: CompanyClient | null | undefined) {
  if (!client) return null

  if (client.name) {
    return client.name
  }

  return client.externalId
}
